export enum LoadTypesEnum {
  none = 'none',
  live = 'live',
  drop = 'drop',
  liveDrop = 'live_drop',
}
